<template>
  <Modal2 :modalId="modalId" ref="modal2">
    <div class="mdl-body-l">
      <h2>通知アドレスの削除</h2>

      <div class="mdl-body-xs">
        <p class="small">
          {{ this.notificationRecipient?.email }} このアドレスを削除してもよろしいですか？
        </p>
      </div><!-- end .mdl-body -->

      <div class="row section-item">
        <div class="modal-footer btn-area">

          <Button class="btn btn-delete" @click="submit">削除する</Button>
          <Button variant="modal-dismiss" ref="dismissModal">
            キャンセル
          </Button>
        </div>
      </div>
    </div>
  </Modal2>
</template>

<script>
/* 準標準ライブラリ */
import { mapGetters, mapActions } from "vuex";
/* 全画面共通 */
import { RepositoryFactory } from "repositories/factory";
import {
  SCREEEN_STATUS_CD,
} from "models/screen-status";

/* コンポーネント */
import { Modal2, Button } from "components";
import { CrossIcon, SendIcon } from "icons";

/* リポジトリファクトリ */
const NotificationRecipientsRepository = RepositoryFactory.get("notification-recipients");

export default {
  name: "NotificationRecipientDeleteModal",
  props: {
    modalId: {
      type: String,
      default: "",
    },
    notificationRecipient: {
      type: Object,
    },
  },
  components: {
    Modal2,
    Button,
  },
  data() {
    return {
      icons: {
        CrossIcon,
        SendIcon,
      },
    };
  },
  computed: {
    ...mapGetters({
      /* ログイン情報 */
      userAccount: "profile/userAccount",
      currentServiceAccount: "service-account/currentServiceAccount",
      currentAsigProject: "asig-project/currentAsigProject",
      /* アプリステータス */
      isScreenActive: "application/isScreenActive",
    }),
  },
  methods: {
    ...mapActions({
      /* 画面ステータス更新 */
      updateScreenStatusCd: "application/updateScreenStatusCd",
      /* 通知制御 */
      resetNotification: "notification/resetState",
      setErrorNotification: "notification/setErrorNotification",
    }),
    async openModal() {
      this.$refs.modal2.openModal();
    },
    async submit() {
      try {
        await NotificationRecipientsRepository.destroy(this.notificationRecipient);
        this.$emit("destroy");
      } catch (err) {
        console.log(err);
        // TODO: 発生したエラーを画面に反映
        this.setErrorNotification({
          message: "予期せぬエラーが発生しました。",
        });
      }
      this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
      this.$refs.modal2.closeModal();
    },
  },
};
</script>
